import { ICommentTribe, ICommentTribeNested, ICommentTribeNestedWithUser, ICommentTribeWithUser } from '../interfaces/comment-tribe.interface';

export const nestComments = (comments: any) => {
  const nestedComments = [];
  const commentsCopy = [...comments];
  for (let i = 0; i < commentsCopy.length; i++) {
    const comment = commentsCopy[i];
    if (comment.parent === null) {
      nestedComments.push(comment);
      commentsCopy.splice(i, 1);
      i--;
    }
  }
  nestComments(nestedComments);
  return nestedComments;
};

export const getNestTribeCommentsWithUser = (comments: ICommentTribeWithUser[]):ICommentTribeNestedWithUser[] => {
  //create fatherId, currentId and init children []
  let newCommentsWithFatherId = [];
  newCommentsWithFatherId = comments.map((comment: ICommentTribeWithUser) => {
    if (comment.thread_array.length > 1) {
      return {
        ...comment,
        fatherId: comment.thread_array.slice(-2, -1).join(''),
        currentId: comment.thread_array.slice(-1).join(''),
        children: [],
      };
    } else {
      return {
        ...comment,
        fatherId: null,
        currentId: comment.thread_array.slice(-1).join(''),
        children: [],
      };
    }
  });

  ///////////////////////////////////////

  const groupDeep: any = {};
  newCommentsWithFatherId.forEach((comment: any) => {
    if (groupDeep[comment.thread_array.length] === undefined) {
      groupDeep[comment.thread_array.length] = [comment];
    } else {
      groupDeep[comment.thread_array.length] = [
        ...groupDeep[comment.thread_array.length],
        comment,
      ];
    }
  });

  const lengthGroup = Object.keys(groupDeep).length;


  for (let i = lengthGroup; i >= 2; i--) {
    // console.log('i:', i);
    if (groupDeep[i.toString()] !== undefined) {
      Object.keys(groupDeep[i.toString()]).forEach((key: string) => {
        Object.keys(groupDeep[(i - 1).toString()]).forEach(
          (highLevelkey: string) => {
            if (
              groupDeep[(i - 1).toString()][highLevelkey].currentId ===
              groupDeep[i.toString()][key].fatherId
            ) {
              if (
                groupDeep[(i - 1).toString()][highLevelkey].children ===
                undefined
              ) {
                groupDeep[(i - 1).toString()][highLevelkey].children = [
                  groupDeep[i.toString()][key],
                ];
              } else {
                groupDeep[(i - 1).toString()][highLevelkey].children = [
                  ...groupDeep[(i - 1).toString()][highLevelkey].children,
                  groupDeep[i.toString()][key],
                ];
              }
            }
          }
        );
      });
    }
  }
  ///////////////////////////////////////

  console.log('groupDeep:', groupDeep['1']);

  return groupDeep['1'];
};






export const getNestTribeComments = (comments: ICommentTribe[]):ICommentTribeNested[] => {
  //create fatherId, currentId and init children []
  // console.log('comments to nested:', comments);
  let newCommentsWithFatherId = [];
  newCommentsWithFatherId = comments.map((comment: ICommentTribe) => {
    if (comment.thread_array.length > 1) {
      return {
        ...comment,
        fatherId: comment.thread_array.slice(-2, -1).join(''),
        currentId: comment.thread_array.slice(-1).join(''),
        children: [],
      };
    } else {
      return {
        ...comment,
        fatherId: null,
        currentId: comment.thread_array.slice(-1).join(''),
        children: [],
      };
    }
  });
// console.log('newCommentsWithFatherId:', newCommentsWithFatherId);
  ///////////////////////////////////////
  /// deep 1 (opinion 3) "03.aazl1697461533067/
  // deep 2 (opinion 2) 03.aazl1697461551338/

  const groupDeep: any = {};
  newCommentsWithFatherId.forEach((comment: any) => {
    if (groupDeep[comment.thread_array.length] === undefined) {
      groupDeep[comment.thread_array.length] = [comment];
    } else {
      groupDeep[comment.thread_array.length] = [
        ...groupDeep[comment.thread_array.length],
        comment,
      ];
    }
  });

  const lengthGroup = Object.keys(groupDeep).length;


  for (let i = lengthGroup; i > 1; i--) {
    // console.log('i:', i);
    if (groupDeep[i.toString()] !== undefined) {
      Object.keys(groupDeep[i.toString()]).forEach((currentKey: string) => {
        Object.keys(groupDeep[(i - 1).toString()]).forEach(
          (highLevelkey: string) => {
            if (
              groupDeep[(i - 1).toString()][highLevelkey].currentId ===
              groupDeep[i.toString()][currentKey].fatherId
            ) {
              if (
                groupDeep[(i - 1).toString()][highLevelkey].children ===
                undefined
              ) {
                groupDeep[(i - 1).toString()][highLevelkey].children = [
                  groupDeep[i.toString()][currentKey],
                ];
              } else {
                groupDeep[(i - 1).toString()][highLevelkey].children = [
                  ...groupDeep[(i - 1).toString()][highLevelkey].children,
                  groupDeep[i.toString()][currentKey],
                ];
              }
            }
          }
        );
      });
    }
  }
  /////////////////////////////////////// todo: validate if parent id donest exist so not inject,

  // console.log('groupDeep:', groupDeep['1']);

  return groupDeep['1'];
};
